import { mapState } from "vuex";

export const computed = {
  ...mapState("agendamentos", ["atendimento"]),
 
}
